export default ({ request }) => ({
  appDeviceStatusListApi(data = {}, params) {
    return request({
      url: '/sys/app/device/list',
      method: 'POST',
      data,
      params
    })
  },
  appDeviceStatusDetailApi(data = {}) {
    return request({
      url: '/sys/app/device/detail',
      method: 'POST',
      data
    })
  },
})
